import { GridColDef } from '@mui/x-data-grid-premium';
import { EnhancedDataGrid } from 'components/enhanced/data-grid';
import TenantPage from 'layouts/TenantPage';
import { useTranslation } from 'react-i18next';
import { workstationService } from 'shared/services';
import { useWorkstationsColumns } from '../hooks/useWorkstationsColumns';
import { AddButton } from 'components/ui';

export const Workstations = () => {
  const { t } = useTranslation();
  const translationPrefix = 'pages.workstation.list';

  const columns: GridColDef[] = useWorkstationsColumns();

  return (
    <TenantPage
      title={t(`${translationPrefix}.title`)}
      subtitle={t(`${translationPrefix}.subtitle`)}
      menuRight={<AddButton prefix={translationPrefix} to="new" requireTenantAdmin />}>
      <EnhancedDataGrid columns={columns} service={workstationService} />
    </TenantPage>
  );
};

export default Workstations;
